import React, { useEffect } from 'react';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Stack from '@mui/material/Stack';

function ErrorAlert({ description, onClose, title = 'Error' }) {
  return (
    <Alert severity="error" onClose={onClose} variant="filled">
      <AlertTitle>{title}</AlertTitle>
      {description}
    </Alert>
  );
}

function WarningAlert({ description, onClose, title = 'Warning' }) {
  return (
    <Alert severity="warning" onClose={onClose} variant="filled">
      <AlertTitle>{title}</AlertTitle>
      {description}
    </Alert>
  );
}

function SuccessAlert({ description, onClose, title = 'Success' }) {
  return (
    <Alert severity="success" onClose={onClose} variant="filled">
      <AlertTitle>{title}</AlertTitle>
      {description}
    </Alert>
  );
}

function InfoAlert({ description, onClose, title = 'Coming Soon!' }) {
  return (
    <Alert severity="info" onClose={onClose}>
      <AlertTitle>{title}</AlertTitle>
      {description}
    </Alert>
  );
}

export default function AlertItem({
  severity,
  description,
  onClose,
  keepOpen = false,
  title = null,
}) {
  useEffect(() => {
    if (severity === 'error') return;

    if (keepOpen) return;

    const timer = setTimeout(() => {
      onClose();
    }, 2000);
    return () => clearTimeout(timer);
  }, [onClose, severity, keepOpen]);

  const isError = severity === 'error';
  const isWarning = severity === 'warning';
  const isSuccess = severity === 'success';
  const isInfo = severity === 'info';
  return (
    <Stack spacing={2} sx={{ width: '100%' }}>
      {isError && (
        <ErrorAlert
          description={description}
          onClose={onClose}
          title={title || 'Error'}
        />
      )}
      {isWarning && (
        <WarningAlert
          description={description}
          onClose={onClose}
          title={title || 'Warning'}
        />
      )}
      {isSuccess && (
        <SuccessAlert
          description={description}
          onClose={onClose}
          title={title || 'Success'}
        />
      )}
      {isInfo && (
        <InfoAlert
          description={description}
          onClose={onClose}
          title={title || 'Coming Soon!'}
        />
      )}
    </Stack>
  );
}
